import styled from "styled-components";

import { Image as LibImage } from "@components/DataDisplay/Image";

export const Root = styled.aside`
  position: absolute;
  inset: 0;
  overflow: hidden;
  background-color: ${props => props.theme.palette.blue500};
  z-index: -1;
`;

export const Image = styled(LibImage)`
  position: absolute;
  bottom: 0;
  max-height: 100%;
  width: 100%;
  height: 100%;
  z-index: -1;

  img {
    object-fit: cover;
    object-position: center right;

    ${props => props.theme.breakpointsV2.smallTablet} {
      object-fit: contain;
      object-position: bottom right;
    }
  }
`;
